// extracted by mini-css-extract-plugin
module.exports = {"tabWithCounter":"ProfilePage_tabWithCounter__38w_n","countBadge":"ProfilePage_countBadge__2gZ7H"};